export default __webpack_public_path__ + "static/media/plusIcon.fe776811.svg";